import { type CSSProperties, type PropsWithChildren } from 'react';
import styled from 'styled-components';

export type ImageBackgroundProps = PropsWithChildren<{
	imageStyle?: React.CSSProperties;
	objectFit?: CSSProperties['objectFit'];
	src: string;
	testID?: string;
}>;

export const ImageBackground = ({ children, imageStyle, objectFit = 'cover', src, testID }: ImageBackgroundProps) => {
	return (
		<S.FullImageWrapper>
			<S.FullImage $objectFit={objectFit} data-testid={testID} src={src} style={imageStyle} />
			{children}
		</S.FullImageWrapper>
	);
};

namespace S {
	export const FullImage = styled.img<{ $objectFit: ImageBackgroundProps['objectFit'] }>`
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		object-fit: ${({ $objectFit }) => $objectFit};
		width: 100%;
		z-index: -1;
	`;
	export const FullImageWrapper = styled.div`
		position: relative;
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
	`;
}
